/**
 * Created by richardlovejoy on 3/7/17.
 */
import _ from 'underscore';
import config from '../constants/Config';

const SECURITY_EXCEPTION_TURN_TOO_FAST = 1;
const SECURITY_EXCEPTION_BALL_MISMATCH = 2;
const SECURITY_EXCEPTION_BONUS_MISMATCH = 3;
const SECURITY_EXCEPTION_SCORE_MISMATCH = 4;
const SECURITY_EXCEPTION_BAD_CUP_ID = 5;

/////////////////////////////////////////////////////////////////////////
// CONSTRUCTOR //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const TurnGenerator = {

  //
  gameData: null,

  // start game - retrieve initial set of balls
  startGame() {

    // generate balls and token
    // (using php naming convention for variables)
    const cup_ids = this.generateCupIDs();
    const newBalls = this.generateBalls(config.numBalls);

    this.gameData = {
      balls: newBalls,
      ids: cup_ids,
      scr: this.cupIDScramble(),
      bonusCup: this.generateBonusCup(cup_ids),
      score: 0
    };


    return {
      newBalls
    }
  },

  endTurn(ballAttributes, cupId, pointsScored) {

    const currentBall = this.gameData.balls.shift();

    let exception = 0;
    if (ballAttributes.multiplier !== currentBall.multiplier)
    {
      exception = SECURITY_EXCEPTION_BONUS_MISMATCH;
    }

    // update score
    const cupScrambles = [
      [2, 4, 1, 6, 3, 0, 5],
      [3, 5, 2, 0, 4, 6, 1],
      [4, 2, 3, 0, 1, 6, 5],
      [0, 3, 2, 6, 4, 5, 1],
      [5, 1, 6, 3, 4, 2, 0],
      [5, 4, 2, 1, 0, 6, 3],
      [0, 3, 1, 2, 6, 4, 5],
      [1, 4, 2, 0, 6, 5, 3],
      [4, 2, 1, 5, 0, 3, 6],
      [1, 5, 3, 4, 6, 0, 2]
    ];
    const cupScramble = cupScrambles[this.gameData.scr];

    let previousScore = this.gameData.score;
    let newScore = 0;
    const points = [10, 20, 30, 40, 50, 100, 100];
    const key = this.gameData.ids.indexOf(cupId);
    if (key < 0) {
      // bad cup id
      exception = SECURITY_EXCEPTION_BALL_MISMATCH;
    }
    else {

      // accumulate score w/ multiplier
      newScore = previousScore + points[cupScramble[key]] * currentBall.multiplier;

      // check score
      if (previousScore + pointsScored !== newScore)
      {
        exception = SECURITY_EXCEPTION_SCORE_MISMATCH;
      }
      // save new score
      this.gameData.score = newScore;

    }

    // check if they won an extra ball (by hitting lit up cup)
    let newBalls = [];
    //console.log('-->', cupId, this.gameData.bonus_cup, newScore, previousScore);
    if (this.gameData.bonusCup !== 0 && cupId === this.gameData.bonusCup) {

      // award extra ball
      newBalls = this.generateBalls(1);
    }

    // if score passed 600, add 3 extra balls
    if (newScore >= 600 && previousScore < 600)
    {
      newBalls = newBalls.concat(this.generateBalls(3));
    }

    this.gameData.balls = this.gameData.balls.concat(newBalls);

    // default is end of game case
    let responseData = {
      exception,
      endgame: true
    };
    if (this.gameData.balls.length > 0)
    {

      // send new balls and cup id's
      let cup_ids = this.generateCupIDs();

      responseData = {
        ...responseData,
        newBalls,
        endgame: false
      };

      // update other session vars
      this.gameData.ids = cup_ids;
      this.gameData.scr = this.cupIDScramble();
      this.gameData.bonusCup = this.generateBonusCup(cup_ids);

    }

    return responseData;
  },

  // helpers
  generateBalls(numBalls) {

    // create an array of balls of random types
    // {color: 'brown', multiplier: 1}
    // 20% chance of RED 2x ball
    // 10% chance of BLUE 4x ball
    const newBalls = [];
    for (let i = 0; i < numBalls; i++)
    {
      // default
      const ball = {
        color: 'brown',
        multiplier: 1
      };

      // upgrade randomly
      const n = Math.random();
      if (n < 0.1)
      {
        ball.color = 'blue';
        ball.multiplier = 4;
      }
      else if (n < 0.3)
      {
        ball.color = 'red';
        ball.multiplier = 2;
      }

      newBalls.push(ball);
    }

    return newBalls;
  },

  generateCupIDs() {
    // each cup ID needs to be a random 4 digit int
    // array elements correspond to cups:
    // 10, 20, 30, 40, 50, 100 (left), 100 (right)

    // no need to check for dupes, just setup a pool
    const pool = [2004,3269,7669,6113,8363,3031,4774,8366,5636,7367,3891,4254,3804,6971,9761,9610,8870,4167,7463,1111,3380,2669,8803,4369,4894,7636,2848,9401,6041,6297];

    return _.shuffle(pool).slice(0, 7);
  },

  cupIDScramble() {

    // return a random code to indicate how cup ids should be scrambled when checking the score
    return Math.floor(Math.random(10));
  },

  generateBonusCup(cup_ids) {

    // randomly pick a cup id or no cup (0)
    if (Math.random() < 0.4)
      return 0;

    return cup_ids[Math.floor(Math.random() * cup_ids.length)];
  },


};

export default TurnGenerator;


// WEBPACK FOOTER //
// ./app/src/logic/TurnGenerator.js